document.addEventListener('DOMContentLoaded', () => {
    const overview = document.querySelector('[data-js-overview]');
    if (!overview) return;

    const filterSelect = overview.querySelector('[data-js-filter-select]');
    if (!filterSelect) return;

    const searchInput = overview.querySelector('[data-js-filter-search]');

    const filterParamKey = filterSelect.name;
    const searchParamKey = searchInput?.name || 'search';
    const options = [...filterSelect.options];
    const items = [...overview.querySelectorAll('[data-js-filter-item]')];
    if (!options.length || !items.length) return;

    const parseValues = (value) =>
        value
            .split('|')
            .map((entry) => entry.split(':')[0]?.trim())
            .filter(Boolean);
    const itemCategories = (item) => parseValues(item.dataset.jsFilterItem);

    const availableFilters = new Set(items.flatMap(itemCategories));

    options.forEach((option) => {
        const value = option.value ?? '';
        if (value === '') return true;
        if (!availableFilters.has(value)) option.remove();
    });

    const optionExists = (value) => [...filterSelect.options].some((option) => option.value === value);
    const defaultValueCandidate = filterSelect.value ?? '';
    const defaultValue = optionExists(defaultValueCandidate) ? defaultValueCandidate : '';
    let currentFilter = defaultValue;
    let currentSearch = '';
    let currentSearchNormalized = '';

    const setSearchValue = (value = '') => {
        currentSearch = value;
        currentSearchNormalized = value.trim().toLowerCase();
    };

    const revealItems = () => items.forEach((item) => item.classList.remove('opacity-0', 'pointer-events-none'));

    setSearchValue(searchInput?.value ?? '');

    const toggleItems = () => {
        items.forEach((item) => {
            const matchesFilter = !currentFilter || itemCategories(item).includes(currentFilter);
            const title = item.dataset.jsFilterItemTitle?.toLowerCase() ?? '';
            const description = item.dataset.jsFilterItemDescription?.toLowerCase() ?? '';
            const searchableContent = `${title} ${description}`.trim();
            const matchesSearch = !currentSearchNormalized || searchableContent.includes(currentSearchNormalized);
            const show = matchesFilter && matchesSearch;
            item.classList.toggle('hidden', !show);
        });
    };

    const syncQueryParam = () => {
        const url = new URL(window.location.href);
        if (currentFilter) url.searchParams.set(filterParamKey, currentFilter);
        else url.searchParams.delete(filterParamKey);
        if (searchInput) {
            if (currentSearch.trim()) url.searchParams.set(searchParamKey, currentSearch);
            else url.searchParams.delete(searchParamKey);
        }
        window.history.replaceState({}, '', url.toString());
    };

    const applyFilter = (value = '', updateUrl = true) => {
        const targetValue = optionExists(value) ? value : defaultValue;
        currentFilter = targetValue;
        filterSelect.value = targetValue;
        toggleItems();
        if (updateUrl) syncQueryParam();
    };

    filterSelect.addEventListener('change', () => applyFilter(filterSelect.value));

    const initialValue = new URLSearchParams(window.location.search).get(filterParamKey) || '';
    applyFilter(initialValue, false);

    const applySearch = (value = '', updateUrl = true) => {
        if (!searchInput) return;
        setSearchValue(value);
        searchInput.value = value;
        toggleItems();
        if (updateUrl) syncQueryParam();
    };

    if (searchInput) {
        const initialSearch = new URLSearchParams(window.location.search).get(searchParamKey) || '';
        applySearch(initialSearch, false);
        revealItems();
        searchInput.addEventListener('input', () => applySearch(searchInput.value));
    } else {
        revealItems();
    }
});
